import { IModelBase } from '../../model';
import { ICollectionState } from './ICollectionState';

export const getCollectionItems = <T extends IModelBase>(
  collection: ICollectionState<T>
): T[] => {
  return collection.ids.map(id => collection.byId[id]);
};
